import React from 'react';
import {Grid, Typography} from "@mui/material";
import useStepsStyles from "../../styles/ncp2026/steps";
import p1 from '../../assets/images/ncp/2026/p1.png';
import p2 from '../../assets/images/ncp/2026/p2.png';
import p3 from '../../assets/images/ncp/2026/p3.png';
import p4 from '../../assets/images/ncp/2026/p4.png';

const Steps: React.FC = () => {
    const stepsStyles = useStepsStyles();

    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid container spacing={2} className={stepsStyles.stepsContainer}>
                    <Grid item md={3} xs={6}>
                        <img 
                            src={p1} 
                            alt={'Pasul 1'} 
                            className={stepsStyles.stepImage}
                        />
                    </Grid>
                    <Grid item md={3} xs={6}>
                        <img 
                            src={p2} 
                            alt={'Pasul 2'} 
                            className={stepsStyles.stepImage}
                        />
                    </Grid>
                    <Grid item md={3} xs={6}>
                        <img 
                            src={p3} 
                            alt={'Pasul 3'} 
                            className={stepsStyles.stepImage}
                        />
                    </Grid>
                    <Grid item md={3} xs={6}>
                        <img 
                            src={p4} 
                            alt={'Pasul 4'} 
                            className={stepsStyles.stepImage}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography className={stepsStyles.textBeforeFormSection}>
                    Selectează magazinul din care ai achiziționat produse Kozel, descoperă premiile din fiecare magazin mai jos și încarcă bonul fiscal
                </Typography>
            </Grid>
        </Grid>
    );
}

export default Steps;